import Navbar from '../src/components/Navbar'
import Home from '../src/components/Home'

function App() {
  return (
    <div>
      <Navbar />
      <Home />
    </div>
  );
}

export default App;
